<script setup>
import { ref, toRefs, inject } from 'vue'
import { ChevronUpDownIcon as SelectorIcon } from '@heroicons/vue/24/solid'
import { formatCurrency } from '@/helpers/text'

const siteConfig = inject('siteConfig')

const emit = defineEmits(['handleAddons'])

const props = defineProps({
  selectedAddon: { type: Object, default: null},
  calculatePrice: { type: Function, default: () => {} }
})

const { selectedAddon, calculatePrice } = toRefs(props)

const openedDroplist = ref(false)

const closeDroplist = () => {
  openedDroplist.value = false
}

const updateSelectedAddon = (option) => {
  if (option && (!selectedAddon.value || selectedAddon.value.id !== option.id)) {
    emit('handleAddons', option)
    closeDroplist()
  } else {
    !option && emit('handleAddons', null)
    closeDroplist()
  }
}
</script>

<template>
  <div class="dropdown-wrapper pt-2 pb-6">
    <div class="flex justify-between">
      <label class="inline-block text-sm mx-1 mb-1 font-semibold">Clay Studio Membership Add-ons:</label>
      <span v-if="selectedAddon?.title" class="text-sm md:hidden">Total: <strong> &dollar;{{ calculatePrice() }} </strong></span>
    </div>
   
    <section
      class="base-dropdown"
      v-click-outside="closeDroplist"
      :class="{ opened: openedDroplist }"
      @click.self="closeDroplist"
    >
      <div class="dropdown-overlay" @click.prevent="closeDroplist"></div>
      <div
        class="selected-item"
        @click.prevent="openedDroplist = !openedDroplist"
        role="button"
      >
        <p
          v-if="selectedAddon?.title"
          :class="{
            'text-secondary-text': !selectedAddon,
          }"
        >
          {{ selectedAddon?.title }} <span class="hidden md:inline-block"> <strong> &dollar;{{ formatCurrency(selectedAddon.price) }} </strong></span>
        </p>
        <p v-else>
          Please select
        </p>
        <button class="selector-btn">
          <SelectorIcon class="icon" />
        </button>
      </div>

      <ul class="dropdown-list" v-if="openedDroplist">
        <li v-if="selectedAddon?.title" class="special-item cursor-pointer hover:underline w-fit" @click="updateSelectedAddon(null)">Clear</li>
        <li v-else class="special-item">Please select</li>
        <li
          class="list-item"
          v-for="(addon) in siteConfig.membershipsAddons"
          :key="addon.id"
          :class="{ selected: selectedAddon?.id === addon.id }"
          @click="updateSelectedAddon(addon)"
        >
          {{ addon.title }} <strong> &dollar;{{ formatCurrency(addon.price) }} </strong>
        </li>
      </ul>
    </section>
  </div>
</template>

<style lang="postcss" scoped>
@import url('@/assets/css/base/dropdown.pcss');
.special-item {
  @apply !text-secondary-text;
}
</style>
